import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import { columnsCurso } from 'components/dashboards/support-desk/unsolved-tickets/TicketsLayout';
import { dataCursos } from 'data/apiConection.js/dataCursos';
import { FaPrint } from 'react-icons/fa';
import { export_excel } from './utils';

const TableViewCurso = () => {
  const [cursos, setCursos] = useState([]);
  const [filteredCursos, setFilteredCursos] = useState([]);
  const [filter, setFilter] = useState('');
  const [desde, setDesde] = useState('');
  const [hasta, setHasta] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const cu = await dataCursos();
        setCursos(cu);
        setFilteredCursos(cu);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    let cursos_filtered = [...cursos];

    if (filter.trim() !== '') {
      const value = filter.toLowerCase();
      cursos_filtered = cursos_filtered.filter(curso =>
        (curso.curso && curso.curso.toLowerCase().includes(value)) ||
        (curso.aula && curso.aula.toLowerCase().includes(value)) ||
        (curso.nivel && curso.nivel.toLowerCase().includes(value))
      );
    }

    if (desde || hasta) {
      const desdeDate = desde ? new Date(desde) : null;
      const hastaDate = hasta ? new Date(hasta) : null;

      cursos_filtered = cursos_filtered.filter(curso => {
        if (!curso.updated_at) return false;
        const updatedDate = new Date(curso.updated_at);

        return (!desdeDate || updatedDate >= desdeDate) &&
               (!hastaDate || updatedDate <= hastaDate);
      });
    }

    setFilteredCursos(cursos_filtered);
  }, [filter, desde, hasta, cursos]);

  return (
    <div>
      <Row className="mb-3">
        <Col>
          <label>Filtro</label>
          <input
            type="text"
            placeholder="Buscar por curso, aula o nivel..."
            className="form-control"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          />
        </Col>
        <Col>
          <label>Desde</label>
          <input
            type="date"
            className="form-control"
            value={desde}
            onChange={(e) => setDesde(e.target.value)}
          />
        </Col>
        <Col>
          <label>Hasta</label>
          <input
            type="date"
            className="form-control"
            value={hasta}
            onChange={(e) => setHasta(e.target.value)}
          />
        </Col>
        <Col><Button onClick={() => export_excel(filteredCursos)}><FaPrint /></Button></Col>
      </Row>
      <Row className="gx-0 mx-0" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        {filteredCursos && (
          <Col xxl={12} xl={12} style={{ height: '100%' }}>
            <AdvanceTableWrapper
              columns={columnsCurso}
              data={filteredCursos}
              selection
              selectionColumnWidth={52}
              sortable
              pagination
              perPage={80}
              rowCount={filteredCursos.length}
            >
              <Card style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <Card.Body className="p-0" style={{ flexGrow: 1, overflowY: 'auto' }}>
                  <AdvanceTable
                    table
                    headerClassName="bg-light text-800 align-middle"
                    rowClassName="btn-reveal-trigger align-middle"
                    tableProps={{
                      size: 'sm',
                      className: 'fs--1 mb-0 w-100 h-100'
                    }}
                  />
                </Card.Body>
                <Card.Footer>
                  <AdvanceTablePagination table />
                </Card.Footer>
              </Card>
            </AdvanceTableWrapper>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default TableViewCurso;

